import * as React from "react";
import { Mic, Square } from "lucide-react";
import { useVoiceInput } from "./useVoiceInput";
import { cn } from "@/lib/utils";

interface VoiceInputButtonProps {
  setText: (text: React.SetStateAction<string>) => void;
}

export function VoiceInputButton({ setText }: VoiceInputButtonProps) {
  const {
    isConfigured,
    isRecording,
    isProcessing,
    handleStartRecording,
    handleStopRecording,
  } = useVoiceInput(setText);

  return (
    isConfigured && (
      <div className="inline-flex items-center">
        <button
          type="button"
          aria-label={isRecording ? "Stop recording" : "Start recording"}
          onClick={isRecording ? handleStopRecording : handleStartRecording}
          disabled={isProcessing}
          className={cn(
            "p-1.5 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-1",
            "transform transition-all duration-200 ease-in-out hover:scale-[1.02]",
            "shadow-sm hover:shadow-sm active:scale-95",
            isRecording
              ? "bg-red-500 hover:bg-red-600 focus:ring-red-400"
              : "bg-gray-100 hover:bg-gray-200 focus:ring-gray-400",
            isProcessing && "opacity-50 cursor-wait",
          )}
        >
          {isProcessing ? (
            <div className="h-4 w-4 animate-spin rounded-full border-2 border-gray-600 border-t-transparent" />
          ) : isRecording ? (
            <Square className="h-4 w-4 text-white transition-transform" />
          ) : (
            <Mic className="h-4 w-4 text-gray-600 transition-transform" />
          )}
        </button>
      </div>
    )
  );
}
